/*
  Author: Shipla, Prasuk
  Info: JS file for InspectionSummary Component
*/
import {
  mapState,
  mapActions
} from "vuex";
import {
  Component,
  Prop,
  Vue
} from "vue-property-decorator";


export default {
  name: "InspectionSummary",

  props: [
    'maximized'
  ],
  computed: {
    user() {

      return this.$store.state.user
    },
    documents() {
      return this.$store.state.documentsInView;
    },
    summary() {
      return this.$store.state.documents;
    },
    consignment_nums() {
      return this.$store.state.consignmentNums
    },
    purchase_orders() {
      return this.$store.state.purchase_orders
    },
    commodities() {
      return Object.keys(this.$store.state.varieties);
    },
    varieties() {
      return this.commodity == "All" ? [] : this.$store.state.varieties[this.commodity]
    },
    inspectionTypes() {
      return this.$store.state.inspectionTypes
    },
    alerts() {
      return this.$store.state.alerts
    },
    growers() {
      return this.$store.state.growers
    },
    inspector() {
      return this.$store.state.inspector
    },
    template() {
      if (this.$store.state.sampleInfo) {
        return "sample";
      } else if (this.$store.state.template) {
        return "info";
      } else if (this.$store.state.report) {
        return "report";
      } else {
        return "summary";
      }
    },
    num_samples() {
      return this.$store.state.num_samples;
    },
    // StartDate(){
    //   var x= new Date(this.$store.state.InspSummFirstDate)
    //   return(x.getFullYear()+"-"+(x.getMonth()+1)>9?(x.getMonth()+1):"0"+(x.getMonth()+1)+"-"+x.getDate())
    // },
    // EndDate(){
    //   return this.$store.state.InspSummLastDate.toDateString()
    // }
  },
};